import React from "react";

const Java_toString = () => {
  return (
    <div>
      <h1>Java toString()</h1>
      <p>This page provides explanations, examples, and common use-cases for Java toString() in Java.</p>
    </div>
  );
};

export default Java_toString;
